











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { CheckStyleKinds, Point } from "../../../domain/drawing";
import { RectangleAreaDrawableMixin } from "./mixins";

@Component
export default class CheckBoxDrawer extends Mixins(RectangleAreaDrawableMixin) {
  @Prop()
  kind: CheckStyleKinds;

  @Prop()
  isChecked: boolean;

  get checkedPoints(): Point[] {
    return [
      new Point(this.rectangle.width * 0.2, this.rectangle.height * 0.5),
      new Point(this.rectangle.width * 0.5, this.rectangle.height * 0.85),
      new Point(this.rectangle.width * 0.85, this.rectangle.height * 0.1),
    ];
  }

  get checkedPointsAsString(): string {
    return Enumerable.from(this.checkedPoints)
      .select(p => p.x + " " + p.y)
      .toArray()
      .join(" ");
  }

  get isCheckStyle(): boolean {
    return (this.kind === CheckStyleKinds.Check);
  }
}
